export const COOKIE_SESSION_TOKEN = "sEprevSessionToken";
export const COOKIE_CSRF_TOKEN = "sEprevAntiCrfToken";
export const COOKIE_PUBLIC_DATA_TOKEN = "sEprevPublicDataToken";
